/* Cart notices (B1 redesign, V1 approved by the developer 2026-10-07). One shared manager for the
 * account cart, drawer recovery and Remove/Undo, so messages never stack or duplicate.
 *   pcCartNote.toast({ text, action: [label, fn], error, persist, ms })   drawer closed
 *   pcCartNote.drawer({ id, text, action, ms })                           top of the line list
 *   pcCartNote.footnote({ text, actions: [[label, fn]...] }) / clearFootnote()   under the subtotal
 *   pcCartNote.removedRow({ row, title, onUndo })                         inline in the removed line's place
 *   pcCartNote.merge({ count, onUndo })   in the drawer when open, else the toast (V1, chosen 2026-10-07)
 */
(() => {
  if (window.pcCartNote) return;
  const css = `
  :root{--pcn-gold:#bf9b30;--pcn-gold-ink:#8a6b14;--pcn-gold-hover:#6f560f;--pcn-cream:#fffaf0;--pcn-line:rgba(191,155,48,.35);
    --pcn-undo-icon:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='black' stroke-width='1.4'%3E%3Cpath d='M5.5 3.5 2.5 6.5l3 3'/%3E%3Cpath d='M2.5 6.5h7a4 4 0 0 1 0 8H7'/%3E%3C/svg%3E")}
  .pcn-live{position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap}
  .pcn-act{appearance:none;background:none;border:0;margin:0;padding:.6rem 1.2rem;min-height:4.4rem;min-width:4.4rem;font:inherit;
    display:inline-flex;align-items:center;gap:.6rem;font-size:1.25rem;letter-spacing:.14em;text-transform:uppercase;
    color:var(--pcn-gold-ink);text-decoration:none;text-underline-offset:4px;text-decoration-thickness:1px;cursor:pointer;white-space:nowrap}
  .pcn-act:hover{color:var(--pcn-gold-hover);text-decoration:underline}
  .pcn-act--undo::before{content:"";width:14px;height:14px;flex:none;background:currentColor;
    -webkit-mask:var(--pcn-undo-icon) center/contain no-repeat;mask:var(--pcn-undo-icon) center/contain no-repeat}
  .pcn-act[aria-busy="true"]{cursor:progress;opacity:.7}
  .pcn-act--undo[aria-busy="true"]::before{animation:pcn-spin .9s linear infinite}
  @keyframes pcn-spin{to{transform:rotate(-360deg)}}
  .pcn-act:focus-visible,.pcn-x:focus-visible{outline:2px solid var(--pcn-gold);outline-offset:2px;border-radius:2px}
  .pcn-sep{opacity:.45;margin:0 .2rem}
  /* toast */
  .pcn-toast{position:fixed;z-index:1002;box-sizing:border-box;display:flex;align-items:center;gap:1rem;max-width:32rem;
    padding:.4rem .8rem .4rem 1.6rem;background:var(--pcn-cream);border:1px solid var(--pcn-line);box-shadow:0 8px 24px rgba(0,0,0,.08);
    font-family:var(--font-body-family);font-size:1.4rem;line-height:1.4;color:rgba(var(--color-foreground),.88);
    opacity:0;transform:translateY(4px);transition:opacity .18s ease-out,transform .18s ease-out}
  .pcn-toast.is-in{opacity:1;transform:none}
  .pcn-toast__msg{margin:0;padding:.8rem 0;flex:1}
  .pcn-toast__msg::before{content:"";display:inline-block;width:6px;height:6px;border-radius:50%;background:var(--pcn-gold);margin:0 .9rem .2rem 0;vertical-align:middle}
  .pcn-toast--error .pcn-toast__msg::before{background:rgb(var(--color-foreground))}
  .pcn-x{appearance:none;background:none;border:0;padding:0;width:4.4rem;height:4.4rem;display:grid;place-items:center;cursor:pointer;color:rgba(var(--color-foreground),.55)}
  .pcn-x:hover{color:rgb(var(--color-foreground))}
  @media (max-width:749px){.pcn-toast{left:1.6rem!important;right:1.6rem!important;top:auto!important;max-width:none;
    bottom:calc(var(--pc-agent-lift,0px) + 1.2rem + env(safe-area-inset-bottom,0px))}}
  html.pcn-toast-open #ads-agent-host{opacity:0!important;visibility:hidden!important;pointer-events:none!important}
  /* drawer note (top of the line list) */
  .pcn-note{position:relative;display:flex;align-items:center;justify-content:space-between;gap:1.2rem;margin:.8rem 0 2rem;padding:.2rem 0 .2rem 1.6rem;
    box-shadow:inset 2px 0 var(--pcn-line);background:linear-gradient(90deg,rgba(191,155,48,.08),rgba(191,155,48,0));animation:pcn-in .22s ease-out;
    font-family:var(--font-body-family);font-size:1.35rem;line-height:1.4;color:rgba(var(--color-foreground),.85)}
  .pcn-note p{margin:.8rem 0}
  .pcn-note--recovery{box-sizing:border-box;flex-wrap:wrap;justify-content:flex-start;gap:.8rem 1.2rem;max-width:48rem;
    margin:1.6rem 0 2.4rem;padding:1.6rem 2rem;text-align:start;line-height:1.55;color:var(--pc-text,#3a332a);animation:none}
  .pcn-note--recovery p{flex-basis:100%;min-width:0;margin:0}
  .pcn-note--recovery .pcn-act{padding:.8rem 1.2rem;border:1px solid var(--pcn-line);white-space:normal}
  .pcn-note--recovery .pcn-act:disabled{opacity:.6;cursor:wait}
  .pcn-note--recovery .pcn-act:focus-visible{outline-color:var(--pcn-gold-ink)}
  /* footnote under the subtotal */
  .pcn-foot{display:flex;flex-wrap:wrap;align-items:center;gap:.2rem 1.2rem;margin:.4rem 0 0;font-size:1.25rem;letter-spacing:.02em;
    color:rgba(var(--color-foreground),.7)}
  .pcn-foot p{margin:0}
  .pcn-foot .pcn-act{font-size:1.25rem}
  /* removed placeholder row */
  .pcn-removed,.pcn-removed td{display:block;width:100%}
  .pcn-removed td{padding:0!important;border:0}
  /* Editorial strip (undo_v2 B, chosen 2026-10-07): small-caps label over the title; the gold rule on the
     left drains over the Undo window and stops while the timer is paused. */
  .pcn-removed__inner{position:relative;display:flex;align-items:center;gap:1.2rem;min-height:7.2rem;width:0;min-width:100%;box-sizing:border-box;
    padding:1.2rem 4px 1.2rem 1.6rem;overflow:hidden;box-shadow:inset 2px 0 var(--pcn-line);
    background:linear-gradient(90deg,rgba(191,155,48,.09),rgba(191,155,48,.02));color:rgba(var(--color-foreground),.88);
    animation:pcn-in .22s ease-out;transition:max-height .2s ease-out,opacity .2s ease-out;max-height:12rem}
  .pcn-removed__text{margin:0;flex:1;min-width:0;display:flex;flex-direction:column;gap:.2rem}
  .pcn-removed__label{font-size:1.05rem;letter-spacing:.18em;text-transform:uppercase;color:var(--pcn-gold-ink)}
  .pcn-removed__title{font-family:var(--font-heading-family);font-size:1.6rem;line-height:1.3;overflow:hidden;
    display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}
  .pcn-drain{position:absolute;left:0;top:0;bottom:0;width:2px;background:var(--pcn-gold);transform-origin:top;
    animation:pcn-drain 8s linear forwards}
  .is-paused .pcn-drain{animation-play-state:paused}
  @keyframes pcn-drain{from{transform:scaleY(1)}to{transform:scaleY(0)}}
  @keyframes pcn-in{from{opacity:0;transform:translateY(-3px)}to{opacity:1;transform:none}}
  @media (max-width:749px){.pcn-removed__inner{min-height:6.4rem}}
  .pcn-removed.is-out .pcn-removed__inner{max-height:0;opacity:0;padding:0;border:0}
  /* The cart page's desktop table keeps the strip a full-width row (display:block collapsed it to its
     content, cutting off the title); the drawer and mobile keep the block layout. */
  /* Undo's text ends at the strip's right inset (the focus ring's room), in line with the TOTAL column;
     min-width keeps the 44px target. */
  @media (min-width:750px){cart-items .pcn-removed{display:table-row}cart-items .pcn-removed>td{display:table-cell}
    cart-items .pcn-removed .pcn-act{padding-right:0}}
  @media (prefers-reduced-motion:reduce){.pcn-toast,.pcn-removed__inner{transition:none}.pcn-removed__inner,.pcn-note,.pcn-drain,.pcn-act--undo::before{animation:none}}
  `;
  const style = document.createElement('style'); style.id = 'pc-cart-notes-css'; style.textContent = css; document.head.append(style);
  const live = document.createElement('div'); live.className = 'pcn-live'; live.setAttribute('aria-live', 'polite'); live.setAttribute('role', 'status');
  document.body.append(live);
  const openDrawer = () => document.querySelector('cart-drawer.active');
  const drawerInner = () => { const d = openDrawer(); return d && d.querySelector(d.classList.contains('is-empty') ? '.drawer__inner-empty' : '.drawer__inner'); };
  // aria-modal hides everything outside the open drawer, so the live region moves inside it.
  const hostLive = () => { const host = drawerInner() || document.body; if (live.parentElement !== host) host.append(live); };
  const say = text => { hostLive(); live.textContent = ''; setTimeout(() => { hostLive(); live.textContent = text; }, 50); };
  const FOCUSABLE = 'button:not([disabled]), a[href], input:not([disabled]), select, textarea';
  const drawerFallback = () => openDrawer()?.querySelector('.drawer__close') || drawerInner()?.querySelector(FOCUSABLE);
  // Dawn's trapFocus computes the first/last boundary from the current DOM: refresh it whenever
  // one of our controls is added or removed inside the open drawer (empty drawer included).
  function retrap(target) {
    const container = drawerInner();
    if (!container) { target?.focus?.({ preventScroll: true }); return; }
    const focus = target && container.contains(target) ? target : container.contains(document.activeElement) ? document.activeElement : null;
    if (typeof trapFocus === 'function') trapFocus(container, focus || container);
    else focus?.focus?.({ preventScroll: true });
  }
  // undo: true adds the return-arrow icon; only Undo actions carry it.
  // busy: true shows the press at once, ignores repeats, and closes the note only after the action
  // resolved; a rejected action leaves the note so it can be tried again.
  const actionButton = (label, fn, after, { undo = false, busy = false } = {}) => {
    const b = document.createElement('button'); b.type = 'button'; b.className = undo ? 'pcn-act pcn-act--undo' : 'pcn-act'; b.textContent = label;
    let running = false;
    b.addEventListener('click', () => {
      if (!busy) { after?.(); fn?.(); return; }
      if (running) return;
      running = true; b.setAttribute('aria-busy', 'true'); b.setAttribute('aria-disabled', 'true');
      let run; try { run = Promise.resolve(fn?.()); } catch (error) { run = Promise.reject(error); }
      run.then(() => after?.(), () => { running = false; b.setAttribute('aria-busy', 'false'); b.setAttribute('aria-disabled', 'false'); });
    });
    return b;
  };
  const drain = host => { const d = document.createElement('span'); d.className = 'pcn-drain'; d.setAttribute('aria-hidden', 'true'); host.append(d); return d; };
  // A timer that pauses while the pointer or focus is inside. The optional drain bar runs on the same
  // clock: the full window as its duration, offset by the time already used. stop.sync() redraws it,
  // e.g. after a drawer redraw re-inserted the node (which restarts CSS animations at full).
  function timed(node, ms, done, bar) {
    let left = ms, start = Date.now(), t = setTimeout(done, left), paused = false;
    const sync = () => {
      if (!bar) return;
      const remaining = paused ? left : Math.max(0, left - (Date.now() - start));
      bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = '';
      bar.style.animationDuration = `${ms}ms`; bar.style.animationDelay = `${remaining - ms}ms`;
    };
    const pause = () => { if (paused) return; paused = true; node.classList.add('is-paused'); clearTimeout(t); left -= Date.now() - start; sync(); };
    // At least 1.5 s after a pause ends; the bar moves back to match, so it never empties before the close.
    const resume = () => { if (!paused) return; paused = false; node.classList.remove('is-paused'); left = Math.max(left, 1500); start = Date.now();
      clearTimeout(t); t = setTimeout(done, left); sync(); };
    node.addEventListener('mouseenter', pause); node.addEventListener('mouseleave', resume);
    node.addEventListener('focusin', pause); node.addEventListener('focusout', resume);
    node.addEventListener('touchstart', pause, { passive: true });
    sync();
    const stop = () => clearTimeout(t); stop.sync = sync;
    return stop;
  }

  let toastNode, toastStop;
  function dismissToast() {
    toastStop?.(); toastStop = null;
    const n = toastNode; toastNode = null;
    document.documentElement.classList.remove('pcn-toast-open');
    if (n) { n.classList.remove('is-in'); setTimeout(() => n.remove(), 200); }
  }
  function placeToast(n) {
    if (matchMedia('(max-width:749px)').matches) return;
    const r = document.getElementById('cart-icon-bubble')?.getBoundingClientRect();
    n.style.top = `${Math.max(8, (r ? r.bottom : 64) + 12)}px`;
    n.style.right = `${Math.max(16, r ? innerWidth - r.right : 16)}px`;
  }
  function toast({ text, action, error = false, persist = false, ms = 7000 }) {
    // With the drawer open, messages go inside it: a fixed toast would sit over Check out on mobile
    // and outside the drawer's focus trap.
    if (openDrawer()) return drawer({ id: error ? 'error' : 'info', text, action, ms: error || persist ? 0 : ms });
    dismissToast(); // one at a time
    const n = document.createElement('div');
    n.className = `pcn-toast${error ? ' pcn-toast--error' : ''}`;
    const msg = document.createElement('p'); msg.className = 'pcn-toast__msg'; msg.textContent = text; n.append(msg);
    if (action) n.append(actionButton(action[0], action[1], dismissToast, action[2]));
    const x = document.createElement('button'); x.type = 'button'; x.className = 'pcn-x'; x.setAttribute('aria-label', 'Dismiss');
    x.innerHTML = '<svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true"><path d="M1 1l10 10M11 1L1 11" stroke="currentColor" stroke-width="1.2"/></svg>';
    x.addEventListener('click', dismissToast); n.append(x);
    document.body.append(n); placeToast(n);
    document.documentElement.classList.add('pcn-toast-open');
    requestAnimationFrame(() => n.classList.add('is-in'));
    toastNode = n; say(text);
    // Errors and the stale-tab notice persist; info auto-hides with pause on hover/focus.
    if (!error && !persist) toastStop = timed(n, ms, dismissToast);
    return n;
  }
  addEventListener('keydown', e => { if (e.key === 'Escape' && toastNode) dismissToast(); });
  addEventListener('resize', () => toastNode && placeToast(toastNode));

  // In-drawer notes, keyed by id: the same message is never rebuilt or re-announced; a note the
  // drawer redraw removed is put back.
  const drawerNotes = new Map();
  const noteHost = inner => inner.querySelector('cart-drawer-items, .drawer__contents') || inner;
  function drawer({ id = 'note', text, action, ms = 8000 }) {
    const inner = drawerInner();
    if (!inner) return null;
    const current = drawerNotes.get(id);
    if (current && current.text === text) { if (!inner.contains(current.n)) { noteHost(inner).prepend(current.n); current.timer?.sync(); retrap(); } return current.n; }
    current?.n.remove();
    const n = document.createElement('div'); n.className = 'pcn-note';
    const p = document.createElement('p'); p.textContent = text; n.append(p);
    const done = () => { const hadFocus = n.contains(document.activeElement); n.remove(); drawerNotes.delete(id); retrap(hadFocus ? drawerFallback() : undefined); };
    if (action) n.append(actionButton(action[0], action[1], done, action[2]));
    noteHost(inner).prepend(n); say(text); retrap();
    drawerNotes.set(id, { n, text, timer: ms ? timed(n, ms, done, drain(n)) : null });
    return n;
  }

  let footNode;
  function footnote({ text, actions = [] }) {
    clearFootnote();
    const n = document.createElement('div'); n.className = 'pcn-foot';
    const p = document.createElement('p'); p.textContent = text; n.append(p);
    for (const [label, fn] of actions) n.append(actionButton(label, fn));
    footNode = n; attachFootnote(); say(text);
    return n;
  }
  function attachFootnote() {
    if (!footNode) return;
    const totals = openDrawer()?.querySelector('.cart-drawer__footer .totals') || document.querySelector('#main-cart-footer .totals');
    if (totals) { if (footNode.previousElementSibling !== totals) { totals.after(footNode); retrap(); } return; }
    // Drawer closed, not on the cart page: the same message as a toast, once per session
    // (a Worker outage must not put an error on every page).
    const text = footNode.querySelector('p').textContent, onceKey = `pcn_once:${text}`;
    if (toastNode) return; // another message is showing: not shown, so not counted
    try { if (sessionStorage.getItem(onceKey)) return; } catch {}
    toast({ text, error: true,
      action: footNode.querySelector('.pcn-act') && [footNode.querySelector('.pcn-act').textContent, () => footNode?.querySelector('.pcn-act')?.click()] });
    try { sessionStorage.setItem(onceKey, '1'); } catch {}
  }
  function clearFootnote() { const hadFocus = footNode?.contains(document.activeElement); footNode?.remove(); footNode = null; if (hadFocus) retrap(drawerFallback()); }

  // Removed rows: kept in the removed line's slot, put back after a drawer redraw.
  const removed = new Set();
  const lineTable = () => document.querySelector('cart-drawer.active tbody, cart-items tbody');
  function placeRow(entry) {
    const table = lineTable();
    if (table) {
      if (entry.tr.parentElement === table) return;
      const rows = [...table.querySelectorAll(':scope > tr.cart-item')];
      table.insertBefore(entry.tr, rows[entry.index] || null);
    } else {
      // Last line removed: keep the row reachable in the empty drawer for the window.
      // In the empty drawer the row goes into the empty-state content (in flow, clickable, and
      // inside the trap); the warnings block would otherwise sit over it.
      const inner = drawerInner();
      const host = inner?.querySelector('.cart-drawer__empty-content') || inner || document.querySelector('cart-items');
      if (!host || host.contains(entry.tr)) return;
      const wrap = document.createElement('table'); wrap.style.width = '100%'; const body = document.createElement('tbody');
      body.append(entry.tr); wrap.append(body); host.prepend(wrap);
    }
  }
  function removedRow({ index, title, onUndo, isLine, ms = 8000 }) {
    const tr = document.createElement('tr'); tr.className = 'pcn-removed';
    const td = document.createElement('td'); td.colSpan = 4;
    const inner = document.createElement('div'); inner.className = 'pcn-removed__inner';
    const p = document.createElement('p'); p.className = 'pcn-removed__text';
    // The title wraps to at most two lines; the full title stays available to pointers and screen readers.
    p.title = `Removed ${title}`; tr.setAttribute('aria-label', `Removed ${title}`);
    const lab = document.createElement('span'); lab.className = 'pcn-removed__label'; lab.textContent = 'Removed'; p.append(lab, ' ');
    const t = document.createElement('span'); t.className = 'pcn-removed__title'; t.textContent = title; p.append(t);
    inner.append(p);
    const entry = { tr, index, timer: null };
    let stop;
    const drop = () => { removed.delete(entry); const w = tr.parentElement?.parentElement; tr.remove(); if (w?.tagName === 'TABLE' && !w.querySelector('tr')) w.remove(); };
    const collapse = () => {
      stop?.();
      const hadFocus = tr.contains(document.activeElement);
      const next = tr.nextElementSibling?.querySelector('cart-remove-button a, cart-remove-button button') || drawerFallback();
      tr.classList.add('is-out'); setTimeout(drop, 220);
      if (hadFocus) retrap(next); else retrap();
    };
    // F108: the press shows at once (busy, spinning arrow) and stays focusable; repeat presses are ignored.
    let busy = false;
    const undo = actionButton('Undo', async () => {
      if (busy) return;
      busy = true; stop?.(); undo.setAttribute('aria-busy', 'true'); undo.setAttribute('aria-disabled', 'true');
      try { await onUndo?.(); }
      catch { busy = false; undo.setAttribute('aria-busy', 'false'); undo.setAttribute('aria-disabled', 'false'); return; } // the row stays so the shopper can try again
      drop();
      // Focus the restored line's first control (quantity), else the drawer's close button.
      // By line identity (Shopify may list a re-added line first), else the old slot.
      const lines = [...(lineTable()?.querySelectorAll(':scope > tr.cart-item') || [])];
      const line = (isLine && lines.find(row => { try { return isLine(row); } catch { return false; } })) || lines[index];
      // (The line's image link is tabindex=-1/aria-hidden: never a focus target.)
      retrap(line?.querySelector('input:not([disabled])') || line?.querySelector('button:not([disabled])') || drawerFallback());
    }, undefined, { undo: true });
    inner.append(undo); const bar = drain(inner);
    td.append(inner); tr.append(td);
    placeRow(entry); removed.add(entry);
    // WCAG 2.2.1: the pause listeners exist before focus lands on Undo.
    stop = entry.timer = timed(tr, ms, collapse, bar);
    retrap(undo);
    if (document.activeElement !== undo) undo.focus({ preventScroll: true });
    say(`${title} removed. Undo available.`);
    return tr;
  }

  // After any drawer/cart redraw: put rows, notes and the footnote back, then refresh the trap.
  function reattach() {
    for (const entry of removed) { const was = entry.tr.parentElement; placeRow(entry); if (entry.tr.parentElement !== was) entry.timer?.sync(); }
    const inner = drawerInner();
    if (inner) for (const { n, timer } of drawerNotes.values()) if (!inner.contains(n)) { noteHost(inner).prepend(n); timer?.sync(); }
    attachFootnote(); hostLive();
    retrap();
  }

  function merge({ count, onUndo }) {
    const text = `${count} ${count === 1 ? 'item' : 'items'} from your saved cart ${count === 1 ? 'was' : 'were'} added`;
    const action = ['Undo', onUndo, { undo: true, busy: true }];
    if (openDrawer()) return drawer({ id: 'merge', text, action });
    return toast({ text, action, ms: 8000 });
  }

  window.pcCartNote = { toast, dismissToast, drawer, footnote, clearFootnote, attachFootnote, reattach, removedRow, merge };

})();
